/**
 * Bundle entry — `wwwroot/Scripts/amri-cart.js`.
 *
 * Loaded by `Views/Checkout/Cart.cshtml` via `@section Scripts`. amri-home is
 * already loaded by the Layout (cart counter, deferred-click etc.) so this
 * bundle only carries cart-page-specific bindings on top.
 */
import './amri'; // ensures `window.Amri` exists (shared with amri-home)
import { initCartPage } from './checkout/cart';

function onReady(callback: () => void): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

onReady(() => {
    initCartPage();
});
